import config from '~/config'

export default ({ redirect }) => {
  if (config.stage === 'production' && location.host === 'izone.withlive.net') {
    redirect('https://izone.withlive-app.com/login')
  }
}
